export default {
  "content": "<path d=\"M15 6.7a1 1 0 00-1.41 0L9 11.3a1 1 0 000 1.4l4.59 4.6A1 1 0 1015 15.88L11.12 12 15 8.13a1 1 0 000-1.41z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  }
};